import {Component, Input, OnInit} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {TicketAssignee, TicketOwner} from "@features/task-manager/constants/task-manager.constants";
import {ContentScope} from "@shared/commands/command-base";
import {GraphqlContentScope} from "@shared/models/graphql-content-scope.model";

@Component({
    standalone: false,
    selector: 'particle-task-comment',
  templateUrl: './task-comment.component.html',
  styleUrls: ['./task-comment.component.scss']
})
export class TaskCommentComponent implements OnInit {
  @Input() dynamicData: any;
  @Input() focusAddCommentBox$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  messageType = 3;
  conversationType = 2;
  hasCommentPermission = true;

  constructor() {
  }

  ngOnInit() {
    this.setCommentPermission();
  }
  private setCommentPermission(): void {
    const permissionType = this.dynamicData.card.permissionLevel;
    if (this.dynamicData.card.scope == GraphqlContentScope.getScope(ContentScope.OrbitaxSupport) &&
      (TicketOwner > permissionType || permissionType > TicketAssignee)) {
      this.hasCommentPermission = false;
    }
  }
}
